var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 327,
    viewBox: "0 0 70 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.66663,
    y: 137.8,
    width: 56.6667,
    height: 126.933,
    fill: "#FF1F00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0667,
    y: 4.06641,
    width: 15.8667,
    height: 27.2,
    fill: "#FF1F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3336 4.71149C36.6305 -3.99158 21.869 2.40349 21.853 14.4724C21.7888 35.8855 22.5902 25.8842 18.7115 29.7629C17.3492 31.1252 17.7178 30.5643 17.6697 50.9676C8.11716 50.9996 9.78404 49.1084 9.70391 74.4803C4.68723 75.2657 1.28933 79.529 1.25728 84.2733L0.664252 302.459C0.616166 316.003 11.5631 326.949 25.1226 326.917L44.388 326.853C57.8833 326.821 68.9104 315.794 68.9425 302.299L69.5355 84.113C69.5515 79.3527 66.1697 75.1054 61.153 74.32L61.2171 54.2533C61.2171 52.362 59.6945 50.8394 57.8032 50.8394L53.3315 50.8554L53.3956 32.0709C53.3956 30.1796 51.8729 28.6569 49.9816 28.6569C49.02 28.6569 49.3085 30.7406 49.3566 14.4083C49.3726 10.7379 47.9301 7.27593 45.3496 4.69546L45.3336 4.71149ZM42.5448 14.4243L42.5127 28.7211L28.6167 28.7691L28.6647 14.5205C28.6808 10.6898 31.8062 7.53237 35.6528 7.53237C39.4835 7.51634 42.5768 10.6097 42.5608 14.4403L42.5448 14.4243ZM44.3559 320.058C44.5162 320.218 43.9712 320.058 25.0905 320.122C15.3136 320.154 7.42796 312.268 7.46001 302.491L7.55618 269.185L62.2268 269.041L62.1307 302.315C62.0986 312.092 54.1328 320.058 44.3559 320.09L44.3559 320.058ZM11.2266 81.1318L59.6304 81.0036C61.3614 81.0036 62.7397 82.382 62.7397 84.113L62.6115 131.972L7.94087 132.116L8.06909 84.2893C8.06909 82.5583 9.49556 81.1318 11.2426 81.1158L11.2266 81.1318ZM16.4997 74.32L16.5478 57.7954L54.4053 57.6992L54.3733 74.2399C14.8328 74.3521 16.4837 74.6246 16.5157 74.336L16.4997 74.32ZM62.5955 138.784C62.2269 262.854 62.4032 262.39 62.2429 262.229L7.5722 262.374L7.92483 138.928L62.5955 138.784ZM24.4655 50.9676L24.5136 35.5649L45.9266 35.5008C46.8883 35.5008 46.5998 33.289 46.5517 50.9035L24.4655 50.9676Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMarker);
export default __webpack_public_path__ + "static/media/red_marker.e4e3417c7e78bc80aa481849e6c7aac6.svg";
export { ForwardRef as ReactComponent };